<template>
  <el-dialog
    v-if="mapLineVisible"
    :title="name"
    custom-class="mapLine"
    :visible.sync="mapLineVisible"
    top="10vh"
    append-to-body
    @close="hidePop"
  >
    <!-- <div class="mb10">
            <span>请选择时间：</span>
            <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" size="mini" value-format="yyyy-MM-dd">
            </el-date-picker>
            <el-button @click="getline()" class="ml-20" type="primary" size="mini">查看轨迹</el-button>
        </div> -->
    <div id="mapLine"></div>
  </el-dialog>
</template>

<script>
import PubSub from "pubsub-js";
import { mapGetters } from "vuex";
export default {
  name: "mapLine",
  computed: {
    ...mapGetters(["cid"]),
  },
  data() {
    const now = new Date();
    const year = now.getFullYear(); // 年
    const month = now.getMonth() + 1; // 月
    const date = now.getDate(); // 日
    return {
      mapLineVisible: false,
      name: "老人行动轨迹",
      PointArr: [
        {
          lat: 36.10339957700999,
          lng: 120.4207801005104,
        },
        {
          lat: 36.10349055332635,
          lng: 120.42113539348455,
        },
        {
          lat: 36.10452708476511,
          lng: 120.42076268466177,
        },
        {
          lat: 36.10480132817409,
          lng: 120.4196557913201,
        },
        {
          lat: 36.10560773716036,
          lng: 120.418951386886,
        },
        {
          lat: 36.10621159088823,
          lng: 120.41900182905378,
        },
        {
          lat: 36.1064641068988,
          lng: 120.41992809616544,
        },
        {
          lng: 120.42201589513277,
          lat: 36.10700627324672,
        },
        {
          lng: 120.42236704579075,
          lat: 36.10708566579729,
        },
        {
          lng: 120.42269817692573,
          lat: 36.107201270041955,
        },
        {
          lng: 120.42239277578172,
          lat: 36.10812797579566,
        },
        {
          lng: 120.42175457671763,
          lat: 36.10947659586882,
        },
        {
          lng: 120.42144906678747,
          lat: 36.11028554037044,
        },
        {
          lng: 120.42134433787885,
          lat: 36.110691285540966,
        },
        {
          lng: 120.42234193234574,
          lat: 36.110931417305515,
        },
      ],
      mapobject: null,
      carMk: null,
      id: "",
      time: ["2023-01-01", `${year}-${month}-${date}`],
    };
  },
  watch: {},
  mounted() {
    let that = this;
    PubSub.subscribe("mapLine", (msg, data) => {
      this.name = data.name + "老人行动轨迹";
      this.getYNSmartCarePosition(data.id, this.time[0], this.time[1]);
    });
  },
  created() {},
  methods: {
    initMap() {
      let that = this;
      that.mapobject = new BMap.Map("mapLine");
      that.mapobject.centerAndZoom(that.PointArr, 15); // 根据经纬度显示地图的范围
      this.mapobject.setViewport(this.PointArr); // 根据提供的地理区域或坐标设置地图视野
      this.mapobject.enableScrollWheelZoom();
      that.addStartMarker(
        new BMap.Point(that.PointArr[0].lng, that.PointArr[0].lat),
        "起点",
        that.mapobject
      );
      var carMk; //先将终点坐标展示的mark对象定义
      //小车行驶图标
      var i = 0;
      var interval = setInterval(function () {
        if (i >= that.PointArr.length) {
          clearInterval(interval);
          return;
        }
        that.drowLine(that.mapobject, that.PointArr[i], that.PointArr[i + 1]); //画线调用
        i = i + 1;
      }, 1000);
    },
    drowLine(map, PointArr, PointArrNext) {
      if (PointArrNext != undefined) {
        var polyline = new BMap.Polyline(
          [
            new BMap.Point(PointArr.lng, PointArr.lat),
            new BMap.Point(PointArrNext.lng, PointArrNext.lat),
          ],
          {
            strokeColor: "green",
            strokeWeight: 7,
            strokeOpacity: 1,
          }
        ); //创建折线
        map.addOverlay(polyline);
        this.addMarkerEnd(
          new BMap.Point(PointArrNext.lng, PointArrNext.lat),
          "小车行驶",
          map,
          PointArrNext,
          new BMap.Point(PointArr.lng, PointArr.lat)
        ); //添加图标
      } else {
        this.addMarkerEnd(
          new BMap.Point(PointArr.lng, PointArr.lat),
          "终点",
          map
        ); //添加终点图标
      }
    },
    addMarkerEnd(point, name, mapInit, trackUnit, prePoint) {
      const icon = require("../assets/images/elderPoint.png");
      const endIcon = require("../assets/images/end.png");
      let drivingPoint = new BMap.Icon(icon, new BMap.Size(40, 40), {
        imageSize: new BMap.Size(40, 40),
      });
      //终点图标
      let terminalPoint = new BMap.Icon(endIcon, new BMap.Size(25, 25), {
        imageSize: new BMap.Size(25, 25),
      });
      if (name == "小车行驶") {
        if (this.carMk) {
          //先判断第一次进来的时候这个值有没有定义，有的话就清除掉上一次的。然后在进行画图标。第一次进来时候没有定义也就不走这块，直接进行画图标
          mapInit.removeOverlay(this.carMk);
        }
        this.carMk = new BMap.Marker(point, {
          icon: drivingPoint,
        }); // 创建标注
        // this.carMk.setRotation(this.getAngle(point, prePoint) - 90); // 旋转的角度
        mapInit.addOverlay(this.carMk); // 将标注添加到地图中
      } else {
        mapInit.removeOverlay(this.carMk);
        this.carMk = new BMap.Marker(point, {
          icon: terminalPoint,
        }); // 创建标注
        mapInit.addOverlay(this.carMk);
      }
    },
    addStartMarker(point, name, mapInit) {
      //终点图标
      const startIcon = require("../assets/images/start.png");
      let start = new BMap.Icon(startIcon, new BMap.Size(25, 25), {
        imageSize: new BMap.Size(25, 25),
      });
      if (name == "起点") {
        let marker = new BMap.Marker(point, {
          icon: start,
        }); // 创建标注
        mapInit.addOverlay(marker); // 将标注添加到地图中
      }
    },
    getAngle(n, next) {
      var ret;
      var w1 = (n.lat / 180) * Math.PI;
      var j1 = (n.lng / 180) * Math.PI;
      var w2 = (next.lat / 180) * Math.PI;
      var j2 = (next.lng / 180) * Math.PI;
      ret =
        4 * Math.pow(Math.sin((w1 - w2) / 2), 2) -
        Math.pow(Math.sin((j1 - j2) / 2) * (Math.cos(w1) - Math.cos(w2)), 2);
      ret = Math.sqrt(ret);
      var temp = Math.sin((j1 - j2) / 2) * (Math.cos(w1) + Math.cos(w2));
      console.log(temp);
      ret = ret / temp;
      ret = (Math.atan(ret) / Math.PI) * 180;
      ret += 90;
      // 这里用如此臃肿的if..else是为了判定追踪单个点的具体情况,从而调整ret的值
      if (j1 - j2 < 0) {
        if (w1 - w2 < 0) {
          ret;
        } else {
          ret = -ret + 180;
        }
      } else {
        if (w1 - w2 < 0) {
          ret = 180 + ret;
        } else {
          ret = -ret;
        }
      }
      return ret;
    },
    hidePop() {
      this.mapLineVisible = false;
    },
    getYNSmartCarePosition(id, start, end) {
      let that = this;
      this.$api
        .getYNSmartCarePosition(id, start, end)
        .then((data) => {
          if (!data || !data.length) {
            that.$message({
              message: "该老人暂无轨迹！",
              type: "success",
            });
            return false;
          }
          data = data.map((item) => {
            item.lng = item.SmartCareLoCardLLONG;
            item.lat = item.SmartCareLoCardLLAT;
            return item;
          });
          this.PointArr = data;
          this.mapLineVisible = true;
          const timer = setTimeout(() => {
            that.initMap();
            clearTimeout(timer);
          }, 1000);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#mapLine {
  width: 920px;
  height: 600px;
}

.charts-content {
  width: 100%;
  height: 400px;
}

.ml-20 {
  margin-left: 10px !important;
}
</style>